var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudflareAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 55,
    viewBox: "0 0 69 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3715 13.2498C47.6637 13.2498 51.5911 21.6034 51.5911 25.5344L46.1909 41.7501H3.48002C1.5163 33.4949 8.55241 30.7759 12.3159 30.4483C11.9887 29.1379 11.924 26.4189 14.2805 24.0603C16.637 21.7016 21.1544 22.0947 22.6263 23.5689C23.1172 19.9654 27.0447 13.2498 36.3715 13.2498Z",
    fill: "#F38020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8906 41.7501L51.5907 25.5208C64.9703 25.1295 66.7144 36.2071 65.5666 41.7501L45.8906 41.7501Z",
    fill: "#FAAE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9244 32.6294L51.591 25.5208H52.9368L50.9532 32.4829C50.8727 32.7655 51.0654 33.0527 51.3574 33.0852L59.1005 33.9473C59.4225 33.9832 59.666 34.2554 59.666 34.5793C59.666 34.9142 59.4063 35.1917 59.0721 35.2138L50.4038 35.7875C50.0352 35.8119 49.703 36.0183 49.5179 36.3379L46.3835 41.7501H44.7826L46.4923 36.4197C46.5881 36.1211 46.3734 35.8134 46.0602 35.8L20.0993 34.6951C19.9128 34.6872 19.7656 34.5336 19.7656 34.3469C19.7656 34.1592 19.9144 34.0052 20.102 33.9987L47.2482 33.0577C47.5345 33.0478 47.7931 32.884 47.9244 32.6294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudflareAnalytics);
export default __webpack_public_path__ + "static/media/cloudflare_analytics.1ea6895fba5d3719176e076ae65a8241.svg";
export { ForwardRef as ReactComponent };